import styled from "styled-components";
export const LITB_COLOR = "#E33124";
export const LITB_NAV_COLOR = "#F2F2F2";
export const Header = styled.header `
	width: auto;
	background-color: #ffffff;
	border-bottom: 1px solid #eee;
`;
export const HeaderContainer = styled.div `
	width: 1200px;
	margin: 0 auto;
`;
export const Triangle = styled.div `
	position: absolute;
	top: -8px;
	left: 50%;
	margin-left: -10px;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-bottom: 10px solid #fff;
	border-right: 10px solid transparent;
	z-index: 10;
`;
export const TriangleShadow = styled(Triangle) `
	top: -10px;
	border-bottom: 10px solid #ddd;
	z-index: 0;
`;
